// @flow

import React from "react";

import "./Spinner.css";

const Spinner = () =>
  <div className="Spinner">
    <div className="Spinner-bounce1" />
    <div className="Spinner-bounce2" />
    <div className="Spinner-bounce3" />
  </div>;

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx